/* eslint-disable no-plusplus */
import axios from "axios";
import { persistor } from "../../store";
import enviroments from "../../enviroments";
import { clearAuthData, getCurrentToken } from "../../hooks/useRefreshToken";
import { limparTokenConexao } from "../conexaoAuth";
import { msalInstance } from "../../utils/auth_azure";

const WHATSAPP_SESSION_PATH = "whatsapp/common/whatsapp/session/v1";

async function disconnectWhatsAppSessionBeforeLogout() {
  try {
    const token = getCurrentToken();
    if (!token || !enviroments.BASE_URL) return;

    const response = await axios.delete(
      `${enviroments.BASE_URL}${WHATSAPP_SESSION_PATH}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: {
          cc: enviroments.CC_MOBILE || "6909b8b9-7dfc-40e2-af74-3d0b25c65248",
        },
        timeout: 4000,
      }
    );

    if (response.status >= 200 && response.status < 300) {
      console.log("[signOut] Sessão do WhatsApp encerrada.");
    }
  } catch (error) {
    console.warn(
      "[signOut] Não foi possível encerrar a sessão do WhatsApp antes do logout.",
      error
    );
  }
}

/**
 * Limpa TODOS os cookies do domínio atual
 */
function clearAllCookies() {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();

    // Limpa para o domínio atual e todos os paths
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`;
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.${window.location.hostname}`;
  }
}

/**
 * Função de logout da aplicação
 * Limpa: Redux Persist, localStorage, sessionStorage, cookies e cache MSAL
 */
export default async function signOut() {
  try {
    console.log("[signOut] Iniciando logout...");

    // 1) Pausar Redux Persist para evitar salvamentos durante logout
    persistor.pause();

    // 2) Limpar cache do MSAL (Azure AD)
    try {
      const accounts = msalInstance.getAllAccounts();
      if (accounts && accounts.length > 0) {
        await Promise.all(
          accounts.map((account) =>
            msalInstance
              .logout({
                account,
                onRedirectNavigate: () => false, // Não redirecionar
              })
              .catch((err) => console.error("[signOut] Erro MSAL:", err))
          )
        );
      }
    } catch (msalError) {
      console.error("[signOut] Erro ao limpar MSAL:", msalError);
    }

    // 3) Encerrar sessão do WhatsApp (quando existir), sem bloquear logout
    await disconnectWhatsAppSessionBeforeLogout();

    // 4) Limpar tokens
    clearAuthData();
    // O JWT do Conexão vive só em memória, mas sem isto sobreviveria à troca de usuário dentro da
    // mesma aba — o próximo login reaproveitaria o token do anterior.
    limparTokenConexao();

    // 5) Purgar Redux Persist (remove persist:sell.it)
    await persistor.purge();

    // 6) Limpar localStorage
    localStorage.clear();

    // 7) Limpar sessionStorage
    sessionStorage.clear();

    // 8) Limpar cookies
    clearAllCookies();

    console.log("[signOut] Logout concluído. Redirecionando...");

    // 9) Limpar o cache session storage
    sessionStorage.removeItem("@token-checked");
    sessionStorage.removeItem("@appbar-token-checked");
    sessionStorage.removeItem("@token-health-check-done");
    sessionStorage.removeItem("sellit-birthday-shown-session");
    sessionStorage.removeItem("sellit-creci-shown-session");
    sessionStorage.removeItem("links_uteis");

    // 10) Redireciona para a página inicial do app
    window.location.href = "/";
  } catch (error) {
    console.error("[signOut] Erro ao fazer logout:", error);

    // Fallback: força limpeza mesmo com erro
    try {
      persistor.purge();
      localStorage.clear();
      sessionStorage.clear();
      clearAllCookies();
    } catch (cleanupError) {
      console.error("[signOut] Erro na limpeza de emergência:", cleanupError);
    }

    window.location.replace("/");
  }
}
